import api from "@/plugins/api/EntryPoint";

export default {
  async createDistributionOrderZakarpattya(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-zakarpattya/create-distribution-order-zakarpattya",
      params,
      callBackFn
    );
  },
  async createDistributionToOrderZakarpattya(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-zakarpattya/create-distribution-to-order-zakarpattya",
      params,
      callBackFn
    );
  },
  async getZakarpattyaAccountDistributionDebt(params, callBackFn) {
    return await api.post(
      "easy-pay-distribution-zakarpattya/get-zakarpattya-account-distribution-debt",
      params,
      callBackFn
    );
  },
};
